import { sectionRenderer } from '@theme/section-renderer';
import { ThemeEvents } from '@theme/events';

class VisualCollectionFilter extends HTMLElement {
  connectedCallback() {
    document.addEventListener(ThemeEvents.FilterUpdate, this.#handleFilterUpdate);
    this.#centerActiveItem();
  }

  disconnectedCallback() {
    document.removeEventListener(ThemeEvents.FilterUpdate, this.#handleFilterUpdate);
  }

  #handleFilterUpdate = () => {
    const sectionId = this.getAttribute('section-id');
    if (!sectionId) return;

    sectionRenderer.renderSection(sectionId, {
      cache: false,
      url: new URL(window.location.href),
    });
  };

  #centerActiveItem() {
    if (!window.matchMedia('(max-width: 749px)').matches) return;

    const viewport = this.querySelector('.visual-collection-filter__viewport');
    const activeItem = this.querySelector('[aria-current="true"]')?.closest('.visual-collection-filter__list-item');

    if (!(viewport instanceof HTMLElement) || !(activeItem instanceof HTMLElement)) return;

    requestAnimationFrame(() => {
      const centeredPosition = activeItem.offsetLeft - (viewport.clientWidth - activeItem.offsetWidth) / 2;
      viewport.scrollTo({ left: Math.max(0, centeredPosition), behavior: 'auto' });
    });
  }
}

if (!customElements.get('visual-collection-filter')) {
  customElements.define('visual-collection-filter', VisualCollectionFilter);
}
